import { UserRole } from "./user-role.js";

export const STAFF_OR_ABOVE = [UserRole.STAFF, UserRole.ADMIN, UserRole.SUPER_ADMIN] as const;

export const ADMIN_OR_ABOVE = [UserRole.ADMIN, UserRole.SUPER_ADMIN] as const;

export const SUPER_ADMIN_ONLY = [UserRole.SUPER_ADMIN] as const;

export const NON_GUEST = [UserRole.STUDENT, UserRole.STAFF, UserRole.ADMIN, UserRole.SUPER_ADMIN] as const;

export const isStaffOrAbove = (role: UserRole | null | undefined): boolean =>
	role != null && (STAFF_OR_ABOVE as readonly string[]).includes(role);

export const isAdminOrAbove = (role: UserRole | null | undefined): boolean =>
	role != null && (ADMIN_OR_ABOVE as readonly string[]).includes(role);

export const isSuperAdmin = (role: UserRole | null | undefined): boolean => role === UserRole.SUPER_ADMIN;

export const isStudent = (role: UserRole | null | undefined): boolean => role === UserRole.STUDENT;

export const isGuest = (role: UserRole | null | undefined): boolean => role === UserRole.GUEST;
